export default function AttrsDirective(module) {
    angular.module(module || 'app')
        .directive('attrs', attrs);

    var id = 0;
    attrs.$inject = ['$parse'];
    function attrs($parse) {
        var directive = {
            priority: 99,
            restrict: 'A',
            link: link
        };
        return directive;

        function link($scope, $element, $attrs) {
            var attrs = $parse($attrs.attrs)($scope);
            if (attrs) {
                for (const [key, value] of Object.entries(attrs)) {
                    $element[0].setAttribute(key, value);
                }
            }
        }
    }
};